import { asyncDefaults, makeAsyncReducer, mergeReducers } from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import { SearchDefaults } from '../props/search';

const search = makeAsyncReducer(types.SEARCH);

export default mergeReducers(asyncDefaults(SearchDefaults), types.PREFIX, search);

export const getSearch = (state) => state.portal.search.data;
